import React from "react"

export const MenuActionsWrap = ({ children }) => (
  <div
    className="flex justify-end"
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      position: "sticky",
      top: 0,
      gap: 10,
      zIndex: 10,
      padding: "8px 0",
      marginBottom: 12,
      background: "#fff",
    }}
  >
    {children}
  </div>
)
